module.exports = __webpack_public_path__ + "static/media/mercado-pago.41afdff5.png";